import styled from 'styled-components';

export const Bullet = styled.div`
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.accent.primary};
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  height: 20px;
  font-size: 10px;
  color: ${({ theme }) => theme.colors.text.inverted};
  font-weight: 600;
  
  @media (min-width: 1200px) {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(25%, -25%);
  }
`;
